import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const GetActiveAlertsResponseDtoSchema = z.object({
  changePct: z.number().nullable(),
  count: z.number(),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
});

const _GetActiveAlertsRequestDtoSchema = z.object({
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetActiveAlertsRequestDto = z.infer<
  typeof _GetActiveAlertsRequestDtoSchema
>;
export type GetActiveAlertsResponseDto = z.infer<
  typeof GetActiveAlertsResponseDtoSchema
>;

export const getActiveAlertsKpi = (
  params?: GetActiveAlertsRequestDto,
  config?: AxiosRequestConfig
) =>
  api
    .get('alerts/dashboard/active-alerts', { params, ...config })
    .then(responseContract(GetActiveAlertsResponseDtoSchema));
